var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#FF6201"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3311 18.9878C19.5947 18.9878 18.9978 19.5851 18.9978 20.3211V37.6545C18.9978 40.5998 21.3857 42.9878 24.3311 42.9878H41.6645C42.4005 42.9878 42.9978 42.3905 42.9978 41.6545C42.9978 40.9185 42.4005 40.3211 41.6645 40.3211H24.3311C22.8583 40.3211 21.6645 39.1278 21.6645 37.6545V20.3211C21.6645 19.5851 21.0675 18.9878 20.3311 18.9878ZM33.6645 21.6545V24.3211H38.4138L34.7058 28.0291C34.5858 28.1505 34.2111 28.3211 34.0391 28.3211H31.9565C31.0778 28.3211 29.9938 28.7411 29.3725 29.3625L24.7061 34.0291C24.1854 34.5505 24.1854 35.4251 24.7061 35.9465C24.9665 36.2065 25.3233 36.3211 25.6645 36.3211C26.0057 36.3211 26.3625 36.2065 26.6229 35.9465L31.2898 31.2798C31.4098 31.1585 31.7845 30.9878 31.9565 30.9878H34.0391C34.9178 30.9878 36.0018 30.5678 36.6231 29.9465L40.3311 26.2384V30.9878H42.9978V22.9878C42.9978 22.2518 42.4005 21.6545 41.6645 21.6545H33.6645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc4);
export default __webpack_public_path__ + "static/media/ic-4.f018d1ccbb74823796e85ec7d7e46433.svg";
export { ForwardRef as ReactComponent };